module.exports = __webpack_public_path__ + "static/media/yt_logo_mono_light.64fce50a.png";